<template>
    <div class="risk-perception-container">
        <div class="refresh-btn" @click="refreshData">
            <i class="el-icon-refresh" :class="{ 'loading': isLoading }"></i>
        </div>

        <!-- 页面标题 -->
        <el-row :gutter="20" class="page-header">
            <el-col :span="24">
                <h1 class="page-title">企业风险感知数据中心</h1>
            </el-col>
        </el-row>

        <!-- 数据加载状态 -->
        <div v-if="isLoading" class="loading-overlay">
            <div class="loading-spinner">
                <i class="el-icon-loading"></i>
                <p>数据加载中...</p>
            </div>
        </div>

        <!-- 顶部关键指标 -->
        <el-row :gutter="24" class="stats-row">
            <el-col :span="6" v-for="(stat, index) in stats" :key="index">
                <el-card class="stat-card box-with-corners">
                    <div class="corner-bottom-left"></div>
                    <div class="corner-bottom-right"></div>
                    <div class="stat-label">{{ stat.label }}</div>
                    <div class="stat-value">{{ stat.value }}</div>
                </el-card>
            </el-col>
        </el-row>

        <div class="tab_content cornor">
            <div class="corner-bottom-left"></div>
            <div class="corner-bottom-right"></div>
            <div class="tab_header">
                <span v-for="tab in tabHeaders" :key="tab.key" :class="{
                    active: activeTab === tab.key
                }" @click="switchTab(tab.key)">{{ tab.label }}</span>
            </div>

            <!-- 汇总Tab内容 -->
            <div v-if="activeTab === 'summary'" class="tab-panel">
                <!-- 仪表盘区域 -->
                <el-row class="gauges-row">
                    <el-col :span="8" v-for="(gauge, index) in gauges" :key="index">
                        <div class="gauge-card">
                            <div class="gauge-chart-container">
                                <div :id="gauge.id" class="gauge-chart"></div>
                            </div>
                            <div class="gauge-title">{{ gauge.title }}</div>
                        </div>
                    </el-col>
                </el-row>
            </div>

            <!-- 报警趋势Tab内容 -->
            <div v-if="activeTab === 'trend'" class="tab-panel">
                <div class="chart-container">
                    <div id="trendChart" class="chart"></div>
                </div>
            </div>

            <!-- 主动安全报警趋势Tab内容 -->
            <div v-if="activeTab === 'safety'" class="tab-panel">
                <div class="chart-container">
                    <div id="safetyChart" class="chart"></div>
                </div>
            </div>
        </div>

        <!-- 排名表格区域 - 第一行 -->
        <el-row :gutter="24" class="tables-row">
            <el-col :span="8" v-for="(table, index) in tables" :key="index">
                <div class="table-card cornor">
                    <div class="corner-bottom-left"></div>
                    <div class="corner-bottom-right"></div>
                    <div slot="header" class="table-title">{{ table.title }}</div>
                    <el-table :data="table.data" size="mini" class="small-table" :highlight-current-row="false">
                        <el-table-column prop="paiming" label="排名" width="80"></el-table-column>
                        <el-table-column prop="chepai" label="车牌号"></el-table-column>
                        <el-table-column prop="cishu" label="次数" width="80"></el-table-column>
                    </el-table>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import * as echarts from 'echarts'

export default {
    name: 'RiskPerceptionCenter',
    data() {
        return {
            // 激活的选项卡
            activeTab: 'summary',
            // 加载状态
            isLoading: false,
            token: sessionStorage.getItem('token'),
            // Tab头部配置
            tabHeaders: [
                { key: 'summary', label: '汇总', isFirst: true },
                { key: 'trend', label: '近7天设备超速、疲劳、夜间报警趋势', isFirst: false },
                { key: 'safety', label: '主动安全报警趋势', isFirst: false }
            ],

            // 顶部统计数据
            stats: [
                { label: '车辆总数(辆)', value: '--' },
                { label: '当前车辆在线数', value: '--' },
                { label: '当前报警车辆数', value: '--' },
                { label: '当前主动安全报警', value: '--' },
            ],

            // 仪表盘配置
            gauges: [
                {
                    id: 'onlineRate',
                    title: '上线率',
                    value: 0,
                },
                {
                    id: 'driftRate',
                    title: '昨日漂移率',
                    value: 0,
                },
                {
                    id: 'faultRate',
                    title: '故障率',
                    value: 0,
                }
            ],

            // 表格数据
            tables: [
                {
                    title: '昨日疲劳报警前5名',
                    data: []
                },
                {
                    title: '昨日超速报警前5名',
                    data: []
                },
                {
                    title: '昨日夜间行车报警前5名',
                    data: []
                }
            ],

            // 图表实例
            chartInstances: {},

            // 动态数据
            chartData: {
                // 报警趋势数据
                trendData: {
                    dates: [],
                    night: [],
                    speed: [],
                    fatigue: []
                },
                // 主动安全报警数据
                safetyData: {
                    dates: [],
                    // 柱体1：主要报警类型
                    laneDeviation: [],
                    distanceWarning: [],
                    driverAbnormal: [],
                    // 柱体2：其他报警类型
                    collisionWarning: [],
                    fatigueDriving: [],
                    autoCapture: [],
                    driverChange: [],
                    phoneCall: [],
                    electricShock: [],
                    minuteDriving: [],
                    monitorFailure: []
                }
            }
        }
    },
    mounted() {
        // 初始化数据
        this.loadData()

        // 监听窗口大小变化，重绘图表
        window.addEventListener('resize', this.handleResize)
    },
    beforeDestroy() {
        // 移除事件监听
        window.removeEventListener('resize', this.handleResize)

        // 停止数据更新
        // this.stopDataUpdate()

        // 销毁图表实例
        Object.values(this.chartInstances).forEach(chart => {
            if (chart && typeof chart.dispose === 'function') {
                chart.dispose()
            }
        })
    },
    watch: {
        activeTab(newVal, oldVal) {
            // Tab切换时重新渲染图表
            this.$nextTick(() => {
                this.initAllCharts()
            })
        }
    },
    methods: {
        // 加载数据
        // 加载数据
        async loadData() {
            this.isLoading = true

            try {
                // 使用 Promise.all 等待所有请求完成
                await Promise.all([
                    this.getCarInfo(),
                    this.getAlarmInfo(),
                    this.getLineChart(), // 折线图
                    this.getBarChart()   // 柱状图
                ]);
            } catch (error) {
                console.error('数据加载失败:', error)
                this.$message.error('数据加载失败，请稍后重试')
            } finally {
                this.isLoading = false
            }
        },

        getCarInfo() {
            return new Promise((resolve, reject) => {
                this.axios
                    .post('ownCarAlarm/getCarList')
                    .then(res => {
                        if (res.data.code == 200) {
                            var statsData = res.data.data;
                            // 更新统计数据
                            this.stats = [
                                { label: '车辆总数(辆)', value: statsData.clzs },
                                { label: '当前车辆在线数', value: statsData.zxs },
                                { label: '当前报警车辆数', value: statsData.bjs },
                                { label: '当前主动安全报警', value: statsData.zdaq },
                            ]

                            // 处理百分比数据 - 将百分比字符串转换为小数
                            this.gauges[0].value = this.parsePercentage(statsData.sxl)
                            this.gauges[1].value = this.parsePercentage(statsData.pyl)
                            this.gauges[2].value = this.parsePercentage(statsData.pyl)

                            // 初始化图表
                            this.$nextTick(() => {
                                this.initAllCharts()
                            })
                            resolve(res.data);
                        } else {
                            this.$message({
                                message: res.data.message,
                                type: 'error',
                            })
                            reject(res.data.message);
                        }
                    })
                    .catch(error => {
                        console.error('API请求失败:', error)
                        this.$message.error('数据加载失败，请稍后重试')
                        reject(error);
                    })
            });
        },

        getAlarmInfo() {
            return new Promise((resolve, reject) => {
                this.axios
                    .post('ownCarAlarm/getAlarmList')
                    .then(res => {
                        if (res.data.code === 200) {
                            var tablesData = res.data.data;
                            // 更新表格数据
                            this.tables[0].data = tablesData.plbj
                            this.tables[1].data = tablesData.csbj
                            this.tables[2].data = tablesData.yjxc
                            resolve(res.data);
                        } else {
                            this.$message({
                                message: res.data.message,
                                type: 'error',
                            })
                            reject(res.data.message);
                        }
                    })
                    .catch(error => {
                        reject(error);
                    })
            });
        },

        getLineChart() {
            return new Promise((resolve, reject) => {
                this.axios
                    .post('ownCarAlarm/getAlarmTrend')
                    .then(res => {
                        if (res.data.code === 200) {
                            let data = res.data.data;
                            let obj = {};
                            const dates = data.map(item => item.date);
                            const speed = data.map(item => item.count_overspeed);
                            const fatigue = data.map(item => item.count_fatigue_driving);
                            const night = data.map(item => item.count_night_driving);
                            obj.dates = dates;
                            obj.speed = speed;
                            obj.fatigue = fatigue;
                            obj.night = night;
                            this.chartData.trendData = obj;
                            resolve(res.data);
                        } else {
                            reject(res.data.message);
                        }
                    })
                    .catch(error => {
                        reject(error);
                    })
            });
        },

        getBarChart() {
            return new Promise((resolve, reject) => {
                this.axios
                    .post('ownCarAlarm/getBarChartData')
                    .then(res => {
                        if (res.data.code === 200) {
                            let safetyData = res.data.data;
                            let safetyDataObj = {};
                            const safetydates = safetyData.map(item => item.date);
                            const cybj = safetyData.map(item => item.cybj);
                            const pljs = safetyData.map(item => item.pljs);
                            const cdpl = safetyData.map(item => item.cdpl);
                            const cjgj = safetyData.map(item => item.cjgj);
                            const jsyxw = safetyData.map(item => item.jsyxw);
                            const qcpz = safetyData.map(item => item.qcpz);
                            const zdzp = safetyData.map(item => item.zdzp);
                            const jsybg = safetyData.map(item => item.jsybg);
                            const jddh = safetyData.map(item => item.jddh);
                            const wjaqd = safetyData.map(item => item.wjaqd);
                            safetyDataObj.dates = safetydates;
                            safetyDataObj.laneDeviation = cdpl;
                            safetyDataObj.distanceWarning = cjgj;
                            safetyDataObj.collisionWarning = qcpz;
                            safetyDataObj.fatigueDriving = pljs;
                            safetyDataObj.autoCapture = zdzp;
                            safetyDataObj.driverChange = jsybg;
                            safetyDataObj.phoneCall = jddh;
                            safetyDataObj.electricShock = cybj;
                            safetyDataObj.minuteDriving = wjaqd;
                            safetyDataObj.monitorFailure = jsyxw;
                            this.chartData.safetyData = safetyDataObj;
                            resolve(res.data);
                        } else {
                            reject(res.data.message);
                        }
                    })
                    .catch(error => {
                        reject(error);
                    })
            });
        },
        // 解析百分比字符串为小数
        parsePercentage(value) {
            if (value === null || value === undefined || value === '--') {
                return 0
            }

            // 如果是字符串，移除百分号并转换为小数
            if (typeof value === 'string') {
                // 移除百分号和空格
                const cleanedValue = value.replace(/%/g, '').trim()
                // 转换为数字并除以100
                const numericValue = parseFloat(cleanedValue)
                return isNaN(numericValue) ? 0 : numericValue / 100
            }

            // 如果是数字，检查是否已经是小数形式
            if (typeof value === 'number') {
                // 如果值大于1，假设是百分比形式（如85），需要转换为小数
                if (value > 1) {
                    return value / 100
                }
                // 如果值小于等于1，假设已经是小数形式
                return value
            }

            return 0
        },

        // Tab切换方法
        switchTab(tabKey) {
            this.activeTab = tabKey
            if (tabKey == 'trend') {
                this.getLineChart();
            } else if (tabKey == 'safety') {
                this.getBarChart();
            } else {
                this.getCarInfo();
            }
        },

        refreshData() {
            // 刷新数据
            this.loadData()
            console.log('数据已刷新')
        },

        // 初始化所有图表
        initAllCharts() {
            // 先销毁所有现有图表
            Object.values(this.chartInstances).forEach(chart => {
                if (chart && typeof chart.dispose === 'function') {
                    chart.dispose()
                }
            })
            this.chartInstances = {}

            if (this.activeTab === 'summary') {
                // 初始化仪表盘
                this.$nextTick(() => {
                    this.gauges.forEach(gauge => {
                        setTimeout(() => {
                            this.initGaugeChart(gauge)
                        }, 100)
                    })
                })
            } else if (this.activeTab === 'trend') {
                // 初始化报警趋势图表
                this.$nextTick(() => {
                    setTimeout(() => {
                        this.initTrendChart()
                    }, 100)
                })
            } else if (this.activeTab === 'safety') {
                // 初始化主动安全报警趋势图表
                this.$nextTick(() => {
                    setTimeout(() => {
                        this.initSafetyChart()
                    }, 100)
                })
            }
        },

        // 初始化等级仪表盘图表
        initGaugeChart(gauge) {
            const chartDom = document.getElementById(gauge.id)

            // 检查DOM元素是否存在
            if (!chartDom) {
                console.error(`找不到图表容器: ${gauge.id}`)
                return
            }

            // 如果已存在实例，先销毁
            if (this.chartInstances[gauge.id]) {
                this.chartInstances[gauge.id].dispose()
            }

            // 使用全局挂载的echarts
            const chart = echarts.init(chartDom)

            // 保存图表实例
            this.chartInstances[gauge.id] = chart

            // 优化后的仪表盘配置 - 增大仪表盘
            const option = {
                series: [
                    {
                        type: 'gauge',
                        startAngle: 180,
                        endAngle: 0,
                        center: ['50%', '50%'],
                        radius: '100%', // 增大半径
                        min: 0,
                        max: 1,
                        splitNumber: 8,
                        axisLine: {
                            lineStyle: {
                                width: 8, // 增加轴线宽度
                                color: [
                                    [0.3, '#FF6E76'],
                                    [0.7, '#FDDD60'],
                                    [1, '#58D9F9']
                                ]
                            }
                        },
                        pointer: {
                            icon: 'path://M12.8,0.7l12,40.1H0.7L12.8,0.7z',
                            length: '25%', // 增加指针长度
                            width: 6, // 增加指针宽度
                            offsetCenter: [0, '-40%'],
                            itemStyle: {
                                color: '#fff'
                            }
                        },
                        axisTick: {
                            length: 10, // 增加刻度长度
                            lineStyle: {
                                color: 'auto',
                                width: 3 // 增加刻度宽度
                            }
                        },
                        splitLine: {
                            length: 18, // 增加分割线长度
                            lineStyle: {
                                color: 'auto',
                                width: 5 // 增加分割线宽度
                            }
                        },
                        axisLabel: {
                            color: '#fff',
                            fontSize: 16, // 增大字体
                            distance: -50,
                            formatter: function (value) {
                                return ''
                            }
                        },
                        title: {
                            show: false
                        },
                        detail: {
                            fontSize: 24, // 增大数值字体
                            offsetCenter: [0, '30%'],
                            valueAnimation: true,
                            formatter: function (value) {
                                return Math.round(value * 100) + '%';
                            },
                            color: '#fff',
                            fontWeight: 'bold'
                        },
                        data: [
                            {
                                value: gauge.value,
                                name: gauge.title
                            }
                        ]
                    }
                ]
            }

            chart.setOption(option)

            // 响应式调整
            setTimeout(() => {
                chart.resize()
            }, 0)
        },

        // 初始化报警趋势图表 - 堆叠面积图
        initTrendChart() {
            const chartDom = document.getElementById('trendChart')

            if (!chartDom) {
                console.error('找不到趋势图表容器')
                return
            }

            // 如果已存在实例，先销毁
            if (this.chartInstances['trendChart']) {
                this.chartInstances['trendChart'].dispose()
            }

            const chart = echarts.init(chartDom)
            this.chartInstances['trendChart'] = chart

            const option = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                        label: {
                            backgroundColor: '#6a7985'
                        }
                    }
                },
                legend: {
                    data: ['夜间', '超速', '疲劳'],
                    textStyle: {
                        color: '#fff'
                    },
                    top: 10
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    top: '15%',
                    containLabel: true
                },
                xAxis: [
                    {
                        type: 'category',
                        boundaryGap: false,
                        data: this.chartData.trendData.dates,
                        axisLine: {
                            lineStyle: {
                                color: '#fff'
                            }
                        },
                        axisLabel: {
                            color: '#fff'
                        }
                    }
                ],
                yAxis: [
                    {
                        type: 'value',
                        axisLine: {
                            lineStyle: {
                                color: '#fff'
                            }
                        },
                        axisLabel: {
                            color: '#fff'
                        },
                        splitLine: {
                            lineStyle: {
                                color: 'rgba(255, 255, 255, 0.2)'
                            }
                        }
                    }
                ],
                series: [
                    {
                        name: '夜间',
                        type: 'line',
                        stack: 'Total',
                        areaStyle: {
                            color: {
                                type: 'linear',
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [{
                                    offset: 0, color: 'rgba(84, 112, 198, 0.8)'
                                }, {
                                    offset: 1, color: 'rgba(84, 112, 198, 0.1)'
                                }]
                            }
                        },
                        emphasis: {
                            focus: 'series'
                        },
                        data: this.chartData.trendData.night,
                        lineStyle: {
                            color: '#5470c6'
                        },
                        itemStyle: {
                            color: '#5470c6'
                        }
                    },
                    {
                        name: '超速',
                        type: 'line',
                        stack: 'Total',
                        areaStyle: {
                            color: {
                                type: 'linear',
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [{
                                    offset: 0, color: 'rgba(145, 204, 117, 0.8)'
                                }, {
                                    offset: 1, color: 'rgba(145, 204, 117, 0.1)'
                                }]
                            }
                        },
                        emphasis: {
                            focus: 'series'
                        },
                        data: this.chartData.trendData.speed,
                        lineStyle: {
                            color: '#91cc75'
                        },
                        itemStyle: {
                            color: '#91cc75'
                        }
                    },
                    {
                        name: '疲劳',
                        type: 'line',
                        stack: 'Total',
                        areaStyle: {
                            color: {
                                type: 'linear',
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [{
                                    offset: 0, color: 'rgba(250, 200, 88, 0.8)'
                                }, {
                                    offset: 1, color: 'rgba(250, 200, 88, 0.1)'
                                }]
                            }
                        },
                        emphasis: {
                            focus: 'series'
                        },
                        data: this.chartData.trendData.fatigue,
                        lineStyle: {
                            color: '#fac858'
                        },
                        itemStyle: {
                            color: '#fac858'
                        }
                    }
                ]
            }

            chart.setOption(option)

            // 响应式调整
            setTimeout(() => {
                chart.resize()
            }, 0)
        },

        // 初始化主动安全报警趋势图表 - 分成两个柱体的堆叠柱状图
        initSafetyChart() {
            const chartDom = document.getElementById('safetyChart')

            if (!chartDom) {
                console.error('找不到安全报警趋势图表容器')
                return
            }

            // 如果已存在实例，先销毁
            if (this.chartInstances['safetyChart']) {
                this.chartInstances['safetyChart'].dispose()
            }

            const chart = echarts.init(chartDom)
            this.chartInstances['safetyChart'] = chart

            const option = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    },
                    formatter: function (params) {
                        let result = params[0].name + '<br/>'
                        params.forEach(item => {
                            result += `${item.marker} ${item.seriesName}: ${item.value}<br/>`
                        })
                        return result
                    }
                },
                legend: {
                    data: [
                        '车道偏离报警', '车距过近报警', '前向碰撞报警',
                        '疲劳驾驶报警', '自动抓拍事件',
                        '驾驶员变更事件', '接打电话报警', '抽烟报警',
                        '未系安全带报警', '驾驶员行为监测功能失效报警'
                    ],
                    textStyle: {
                        color: '#fff',
                        fontSize: 12
                    },
                    top: 10,
                    type: 'scroll',
                    pageTextStyle: {
                        color: '#fff'
                    },
                    pageIconColor: '#fff',
                    pageIconInactiveColor: '#666'
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '15%',
                    top: '25%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    data: this.chartData.safetyData.dates,
                    axisLine: {
                        lineStyle: {
                            color: '#fff'
                        }
                    },
                    axisLabel: {
                        color: '#fff',
                        fontSize: 12
                    }
                },
                yAxis: {
                    type: 'value',
                    axisLine: {
                        lineStyle: {
                            color: '#fff'
                        }
                    },
                    axisLabel: {
                        color: '#fff',
                        formatter: function (value) {
                            if (value >= 1000) {
                                return (value / 1000).toFixed(1) + 'k'
                            }
                            return value
                        }
                    },
                    splitLine: {
                        lineStyle: {
                            color: 'rgba(255, 255, 255, 0.2)',
                            type: 'dashed'
                        }
                    }
                },
                series: [
                    // 柱体1：主要报警类型
                    {
                        name: '车道偏离报警',
                        type: 'bar',
                        stack: 'group1',
                        barWidth: '15%',
                        emphasis: {
                            focus: 'series'
                        },
                        data: this.chartData.safetyData.laneDeviation,
                        itemStyle: {
                            color: '#91cc75'
                        }
                    },
                    {
                        name: '车距过近报警',
                        type: 'bar',
                        stack: 'group1',
                        barWidth: '15%',
                        emphasis: {
                            focus: 'series'
                        },
                        data: this.chartData.safetyData.distanceWarning,
                        itemStyle: {
                            color: '#fac858'
                        }
                    },
                    // {
                    //     name: '驾驶员异常报警',
                    //     type: 'bar',
                    //     stack: 'group1',
                    //     barWidth: '15%',
                    //     emphasis: {
                    //         focus: 'series'
                    //     },
                    //     data: this.chartData.safetyData.driverAbnormal,
                    //     itemStyle: {
                    //         color: '#b6a2de'
                    //     }
                    // },
                    // 柱体2：其他报警类型
                    {
                        name: '前向碰撞报警',
                        type: 'bar',
                        stack: 'group1',
                        barWidth: '15%',
                        emphasis: {
                            focus: 'series'
                        },
                        data: this.chartData.safetyData.collisionWarning,
                        itemStyle: {
                            color: '#5470c6'
                        }
                    },
                    {
                        name: '疲劳驾驶报警',
                        type: 'bar',
                        stack: 'group2',
                        barWidth: '15%',
                        emphasis: {
                            focus: 'series'
                        },
                        data: this.chartData.safetyData.fatigueDriving,
                        itemStyle: {
                            color: '#ee6666'
                        }
                    },
                    {
                        name: '自动抓拍事件',
                        type: 'bar',
                        stack: 'group2',
                        barWidth: '15%',
                        emphasis: {
                            focus: 'series'
                        },
                        data: this.chartData.safetyData.autoCapture,
                        itemStyle: {
                            color: '#73c0de'
                        }
                    },
                    {
                        name: '驾驶员变更事件',
                        type: 'bar',
                        stack: 'group2',
                        barWidth: '15%',
                        emphasis: {
                            focus: 'series'
                        },
                        data: this.chartData.safetyData.driverChange,
                        itemStyle: {
                            color: '#3ba272'
                        }
                    },
                    {
                        name: '接打电话报警',
                        type: 'bar',
                        stack: 'group2',
                        barWidth: '15%',
                        emphasis: {
                            focus: 'series'
                        },
                        data: this.chartData.safetyData.phoneCall,
                        itemStyle: {
                            color: '#fc8452'
                        }
                    },
                    {
                        name: '抽烟报警',
                        type: 'bar',
                        stack: 'group2',
                        barWidth: '15%',
                        emphasis: {
                            focus: 'series'
                        },
                        data: this.chartData.safetyData.electricShock,
                        itemStyle: {
                            color: '#9a60b4'
                        }
                    },
                    {
                        name: '未系安全带报警',
                        type: 'bar',
                        stack: 'group2',
                        barWidth: '15%',
                        emphasis: {
                            focus: 'series'
                        },
                        data: this.chartData.safetyData.minuteDriving,
                        itemStyle: {
                            color: '#ea7ccc'
                        }
                    },
                    {
                        name: '驾驶员行为监测功能失效报警',
                        type: 'bar',
                        stack: 'group2',
                        barWidth: '15%',
                        emphasis: {
                            focus: 'series'
                        },
                        data: this.chartData.safetyData.monitorFailure,
                        itemStyle: {
                            color: '#91cc75'
                        }
                    }
                ]
            }

            chart.setOption(option)

            // 响应式调整
            setTimeout(() => {
                chart.resize()
            }, 0)
        },

        // 处理窗口大小变化
        handleResize() {
            // 重绘所有图表
            Object.values(this.chartInstances).forEach(chart => {
                if (chart && typeof chart.resize === 'function') {
                    chart.resize()
                }
            })
        }
    }
}
</script>

<style scoped>
/* 样式保持不变 */
.risk-perception-container {
    position: relative;
    background-image: url('../../assets/images/car/bg.jpg');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    color: #e6e6e6;
    padding: 20px;
    min-height: 100vh;
}

.page-header {
    margin-bottom: 20px;
}

.page-title {
    width: 1633px;
    height: 69px;
    color: #fff;
    text-align: center;
    font-size: 24px;
    margin: 0;
    padding: 10px 0;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
    background: url('../../assets/images/car/line.png') no-repeat center center;
}

.stats-row {
    margin-bottom: 20px;
}

.stat-card {
    background-color: transparent;
    border: none;
    color: #fff;
    text-align: left;
    height: 100%;
    border: 1px solid #0A7FE3;
    border-radius: 0 !important;
}

.stat-label {
    color: #0A7FE3;
    font-size: 20px;
    margin-bottom: 5px;
}

.stat-value {
    font-size: 30px;
    font-weight: bold;
    color: #4fd1c5;
}

.tab_content {
    position: relative;
    border: 1px solid #0A7FE3;
    margin-bottom: 20px;
}

.tab_header {
    display: inline-block;
    margin: 20px;
    font-size: 16px;
    height: 50px;
    line-height: 50px;
    background-color: #020c5f;
}

.tab_header>span {
    padding: 0 20px;
    box-sizing: border-box;
    opacity: 0.5;
    cursor: pointer;
    transition: all 0.3s;
}

.tab_header>span.active {
    display: inline-block;
    opacity: 1;
    height: 100%;
    background-color: #0A7FE3;
    color: #fff;
}

.tab_header_item.active {
    background-color: #4fd1c5;
}

.tab-panel {
    /* padding: 20px; */
}

.chart-container {
    height: 400px;
    width: 100%;
}

.chart {
    width: 100%;
    height: 100%;
}

/* 仪表盘样式 */
.gauges-row {
    margin-top: 20px;
}

.gauge-card {
    /* background-color: rgba(20, 40, 75, 0.8); */
    /* border: 1px solid #0A7FE3; */
    border-radius: 4px;
    padding: 20px;
    height: 320px;
    /* 增加高度 */
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.gauge-title {
    color: #fff;
    font-size: 18px;
    /* 增大标题字体 */
    font-weight: 500;
    text-align: center;
    margin-bottom: 20px;
}

.gauge-chart-container {
    position: relative;
    height: 240px;
    /* 增加容器高度 */
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.gauge-chart {
    width: 100%;
    height: 100%;
    min-height: 220px;
    /* 增加最小高度 */
}

/* 修复四个角位置偏移问题 */
.cornor {
    position: relative;
}

.cornor::before,
.cornor::after,
.cornor .corner-bottom-left,
.cornor .corner-bottom-right {
    position: absolute;
    z-index: 999;
    pointer-events: none;
}

.cornor::before {
    content: " ";
    top: -2px;
    left: -5px;
    width: 78px;
    height: 60px;
    background: url('../../assets/images/car/top_left.png') no-repeat center center;
    background-size: contain;
}

.cornor::after {
    content: " ";
    top: -2px;
    right: -5px;
    width: 78px;
    height: 60px;
    background: url('../../assets/images/car/top_right.png') no-repeat center center;
    background-size: contain;
}

.cornor .corner-bottom-left {
    bottom: -2px;
    left: -5px;
    width: 78px;
    height: 60px;
    background: url('../../assets/images/car/bottom_left.png') no-repeat center center;
    background-size: contain;
}

.cornor .corner-bottom-right {
    bottom: -2px;
    right: -5px;
    width: 109px;
    height: 100px;
    background: url('../../assets/images/car/bottom_right.png') no-repeat center center;
    background-size: contain;
}

.table-card {
    position: relative;
    background-color: transparent;
    border: 1px solid #0A7FE3;
    backdrop-filter: blur(0px);
    min-height: 320px;
}

.table-title {
    color: #0A7FE3;
    height: 40px;
    line-height: 40px;
    font-size: 16px;
    font-weight: 500;
    padding-left: 10px;
}

::v-deep .el-table {
    background-color: transparent;
    color: #e2e8f0;
}

::v-deep .el-table th {
    background-color: rgba(26, 54, 93, 0.6);
    color: #e2e8f0;
    border-bottom-color: #2d3748;
}

::v-deep .el-table tr {
    background-color: transparent;
}

::v-deep .el-table tr:nth-child(even) {
    background-color: rgba(26, 54, 93, 0.6);
}

::v-deep .el-table td {
    border-bottom-color: #2d3748;
    background-color: transparent;
    text-align: center;
}

.small-table {
    font-size: 12px;
}

.refresh-btn {
    position: absolute;
    top: 0;
    right: 30px;
    font-size: 25px;
    color: #4fd1c5;
    cursor: pointer;
    width: 40px;
    height: 40px;
    text-align: center;
}

.refresh-btn .loading {
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

.loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 99;
}

.loading-spinner {
    text-align: center;
    color: #fff;
}

.loading-spinner i {
    font-size: 40px;
    margin-bottom: 10px;
}

.box-with-corners {
    position: relative;
    border: 1px solid #0A7FE3;
}

.box-with-corners::before {
    content: '';
    position: absolute;
    top: 2px;
    left: 2px;
    width: 0;
    height: 0;
    border-top: 10px solid #0A7FE3;
    border-right: 10px solid transparent;
}

.box-with-corners::after {
    content: '';
    position: absolute;
    top: 2px;
    right: 2px;
    width: 0;
    height: 0;
    border-top: 10px solid #0A7FE3;
    border-left: 10px solid transparent;
}

.box-with-corners .corner-bottom-left {
    position: absolute;
    bottom: 2px;
    left: 2px;
    width: 0;
    height: 0;
    border-bottom: 10px solid #0A7FE3;
    border-right: 10px solid transparent;
}

.box-with-corners .corner-bottom-right {
    position: absolute;
    bottom: 2px;
    right: 2px;
    width: 0;
    height: 0;
    border-bottom: 10px solid #0A7FE3;
    border-left: 10px solid transparent;
}

.table-card {
    position: relative;
    background-color: transparent;
    border: 1px solid #0A7FE3;
    backdrop-filter: blur(0px);
}

/deep/.el-table::before {
    background-color: transparent !important;
}

::v-deep .table-card .small-table.el-table .has-gutter tr th {
    background: rgba(26, 54, 93, 0.6) !important;
    background-color: rgba(26, 54, 93, 0.6) !important;
    color: #e2e8f0 !important;
    border: none !important;
}

::v-deep .table-card .small-table.el-table .has-gutter tr {
    background-color: transparent !important;
}

::v-deep .table-card .small-table.el-table .no-hover-row:hover>td {
    background-color: inherit !important;
}

::v-deep .table-card .small-table.el-table .no-hover-row:hover {
    background-color: inherit !important;
}

::v-deep .table-card .small-table.el-table tbody tr:hover>td {
    background-color: inherit !important;
}

::v-deep .el-table__empty-text {
    margin-top: 80px;
}

.risk-perception-container {
    min-height: calc(100vh - 126px);
    padding: 18px;
    background:
        radial-gradient(circle at 12% 0%, rgba(23, 139, 255, 0.14) 0, rgba(23, 139, 255, 0) 30%),
        linear-gradient(135deg, #eef6ff 0%, #f7fbff 48%, #edf5fc 100%);
    color: var(--fszs-text);
}

.risk-perception-container::before {
    content: '';
    position: absolute;
    inset: 0;
    pointer-events: none;
    background-image:
        linear-gradient(rgba(23, 139, 255, 0.045) 1px, transparent 1px),
        linear-gradient(90deg, rgba(23, 139, 255, 0.045) 1px, transparent 1px);
    background-size: 34px 34px;
    mask-image: linear-gradient(180deg, rgba(0, 0, 0, 0.75), transparent 72%);
}

.refresh-btn {
    top: 18px;
    right: 24px;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid rgba(220, 230, 242, 0.96);
    border-radius: 12px;
    background: rgba(255, 255, 255, 0.92);
    color: var(--fszs-primary);
    box-shadow: var(--fszs-shadow-sm);
}

.page-header {
    position: relative;
    z-index: 1;
    margin-bottom: 16px;
}

.page-title {
    width: 100%;
    height: auto;
    padding: 18px 68px;
    border: 1px solid rgba(220, 230, 242, 0.96);
    border-radius: var(--fszs-radius-lg);
    background:
        linear-gradient(90deg, rgba(23, 139, 255, 0.10) 0%, rgba(255, 255, 255, 0.95) 34%, rgba(255, 255, 255, 0.95) 66%, rgba(23, 139, 255, 0.10) 100%);
    color: var(--fszs-text-strong);
    font-size: 24px;
    font-weight: 800;
    letter-spacing: 2px;
    text-shadow: none;
    box-shadow: var(--fszs-shadow-sm);
    box-sizing: border-box;
}

.stats-row,
.tables-row,
.tab_content {
    position: relative;
    z-index: 1;
}

.stats-row {
    margin-bottom: 16px;
}

.stat-card {
    min-height: 118px;
    padding: 18px 20px;
    border: 1px solid rgba(220, 230, 242, 0.96) !important;
    border-radius: var(--fszs-radius-lg) !important;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.98) 0%, rgba(248, 251, 255, 0.96) 100%);
    color: var(--fszs-text);
    box-shadow: var(--fszs-shadow-sm);
}

.stat-label {
    color: var(--fszs-text-muted);
    font-size: 15px;
    font-weight: 600;
}

.stat-value {
    margin-top: 12px;
    color: var(--fszs-primary);
    font-size: 32px;
    line-height: 1.1;
}

.box-with-corners::before,
.box-with-corners::after,
.box-with-corners .corner-bottom-left,
.box-with-corners .corner-bottom-right {
    display: none;
}

.tab_content {
    padding: 16px;
    margin-bottom: 16px;
    border: 1px solid rgba(220, 230, 242, 0.96);
    border-radius: var(--fszs-radius-lg);
    background: rgba(255, 255, 255, 0.96);
    box-shadow: var(--fszs-shadow-sm);
}

.tab_header {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    height: auto;
    line-height: 1.4;
    margin: 0 0 16px;
    padding: 6px;
    border: 1px solid var(--fszs-border-soft);
    border-radius: 999px;
    background: #f8fbff;
}

.tab_header>span {
    display: inline-flex;
    align-items: center;
    min-height: 38px;
    padding: 0 18px;
    border-radius: 999px;
    color: var(--fszs-text-muted);
    opacity: 1;
}

.tab_header>span.active {
    min-height: 38px;
    background: linear-gradient(135deg, var(--fszs-primary) 0%, var(--fszs-primary-strong) 100%);
    color: #ffffff;
    box-shadow: 0 8px 18px rgba(23, 139, 255, 0.22);
}

.chart-container {
    height: 390px;
    padding: 8px;
    border: 1px solid var(--fszs-border-soft);
    border-radius: var(--fszs-radius-md);
    background: #fbfdff;
    box-sizing: border-box;
}

.gauges-row {
    margin-top: 0;
}

.gauge-card {
    height: 300px;
    margin: 0 8px 8px;
    padding: 16px;
    border: 1px solid var(--fszs-border-soft);
    border-radius: var(--fszs-radius-md);
    background: #fbfdff;
}

.gauge-title {
    color: var(--fszs-text-strong);
    font-size: 16px;
    margin-bottom: 0;
}

.gauge-chart-container {
    height: 230px;
}

.cornor::before,
.cornor::after,
.cornor .corner-bottom-left,
.cornor .corner-bottom-right {
    display: none;
}

.tables-row {
    margin-top: 0;
}

.table-card {
    min-height: 320px;
    padding: 14px;
    border: 1px solid rgba(220, 230, 242, 0.96);
    border-radius: var(--fszs-radius-lg);
    background: rgba(255, 255, 255, 0.96);
    box-shadow: var(--fszs-shadow-sm);
    box-sizing: border-box;
}

.table-title {
    height: auto;
    line-height: 1.4;
    padding: 0 0 12px;
    color: var(--fszs-text-strong);
    font-size: 16px;
    font-weight: 700;
}

::v-deep .el-table {
    border: 1px solid var(--fszs-border-soft);
    border-radius: var(--fszs-radius-md);
    background-color: #ffffff;
    color: var(--fszs-text);
    overflow: hidden;
}

::v-deep .table-card .small-table.el-table .has-gutter tr th,
::v-deep .el-table th {
    background: linear-gradient(180deg, #f4f9ff 0%, #edf6ff 100%) !important;
    color: var(--fszs-text-strong) !important;
    border-bottom-color: var(--fszs-border-soft) !important;
}

::v-deep .el-table tr,
::v-deep .table-card .small-table.el-table .has-gutter tr {
    background-color: #ffffff !important;
}

::v-deep .el-table tr:nth-child(even) {
    background-color: #fbfdff !important;
}

::v-deep .el-table td {
    border-bottom-color: var(--fszs-border-soft);
    background-color: transparent;
    color: var(--fszs-text);
}

::v-deep .table-card .small-table.el-table tbody tr:hover>td {
    background-color: var(--fszs-primary-faint) !important;
}

::v-deep .el-table__empty-text {
    color: var(--fszs-text-subtle);
}

.loading-overlay {
    background-color: rgba(16, 32, 51, 0.32);
    backdrop-filter: blur(4px);
}

.loading-spinner {
    padding: 26px 32px;
    border: 1px solid rgba(220, 230, 242, 0.96);
    border-radius: var(--fszs-radius-lg);
    background: rgba(255, 255, 255, 0.96);
    color: var(--fszs-primary);
    box-shadow: var(--fszs-shadow-md);
}

@media screen and (max-width: 1280px) {
    .risk-perception-container {
        padding: 12px;
    }

    .page-title {
        padding: 16px 56px 16px 18px;
        font-size: 20px;
        text-align: left;
    }

    .stats-row /deep/.el-col,
    .tables-row /deep/.el-col {
        width: 50%;
        margin-bottom: 12px;
    }

    .gauge-card {
        margin: 0 0 12px;
    }
}

@media screen and (max-width: 768px) {
    .risk-perception-container {
        padding: 8px;
        overflow-x: hidden;
    }

    .refresh-btn {
        top: 12px;
        right: 12px;
        width: 34px;
        height: 34px;
        font-size: 20px;
    }

    .page-title {
        padding: 14px 48px 14px 14px;
        font-size: 18px;
        line-height: 1.35;
        letter-spacing: 1px;
    }

    .stats-row,
    .gauges-row,
    .tables-row {
        margin-left: 0 !important;
        margin-right: 0 !important;
    }

    .stats-row /deep/ .el-col,
    .gauges-row /deep/ .el-col,
    .tables-row /deep/ .el-col {
        width: 100% !important;
        padding-left: 0 !important;
        padding-right: 0 !important;
        margin-bottom: 10px;
    }

    .stat-card {
        min-height: 96px;
        padding: 14px;
    }

    .stat-label {
        font-size: 14px;
    }

    .stat-value {
        margin-top: 8px;
        font-size: 26px;
    }

    .tab_content {
        padding: 10px;
    }

    .tab_header {
        display: flex;
        flex-wrap: wrap;
        border-radius: 12px;
    }

    .tab_header>span,
    .tab_header>span.active {
        flex: 1 1 100%;
        min-height: 36px;
        justify-content: center;
        padding: 0 10px;
        text-align: center;
    }

    .chart-container {
        height: 300px;
        padding: 6px;
    }

    .gauge-card {
        height: 260px;
        margin: 0 0 10px;
        padding: 12px;
    }

    .gauge-chart-container {
        height: 200px;
    }

    .gauge-chart {
        min-height: 190px;
    }

    .table-card {
        min-height: 260px;
        padding: 10px;
    }

    ::v-deep .el-table {
        width: 100% !important;
    }
}
</style>